import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-borders" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Access", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Access granted")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Access revoked")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_members_update_supervisor = _resolveComponent("members-update-supervisor")!
  const _component_members_update_hierarchy_assignment = _resolveComponent("members-update-hierarchy-assignment")!
  const _component_members_update_reporting = _resolveComponent("members-update-reporting")!
  const _component_members_update_phone = _resolveComponent("members-update-phone")!
  const _component_members_update_role = _resolveComponent("members-update-role")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_members_update_supervisor, { member: _ctx.memberOrganizationInfoModel }, null, 8, ["member"]),
    _createVNode(_component_members_update_hierarchy_assignment, { member: _ctx.memberOrganizationInfoModel }, null, 8, ["member"]),
    _createVNode(_component_members_update_reporting, { member: _ctx.memberOrganizationInfoModel }, null, 8, ["member"]),
    _createVNode(_component_members_update_phone, { member: _ctx.memberOrganizationInfoModel }, null, 8, ["member"]),
    _createVNode(_component_members_update_role, { member: _ctx.memberOrganizationInfoModel }, null, 8, ["member"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_q_list, {
        class: "q-mb-lg",
        bordered: "",
        padding: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.memberOrganizationInfoModel.accessGranted), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.memberOrganizationInfoModel.accessRevoked), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}